import { c as _c } from "react/compiler-runtime";
import type { SerializedLexicalNode, Spread, LexicalEditor, EditorConfig, NodeKey } from "lexical";
import { DecoratorNode } from "lexical";
import { createElement, type JSX } from "react";
import { useEmoji } from "@/contexts/EmojiContext";
type SerializedEmojiNode = Spread<{
  emojiId: string;
}, SerializedLexicalNode>;
export class EmojiNode extends DecoratorNode<JSX.Element> {
  __emojiId: string;
  constructor(emojiId: string, key?: NodeKey) {
    super(key);
    this.__emojiId = emojiId;
  }
  static override getType(): string {
    return "emoji";
  }
  static override clone(node: EmojiNode): EmojiNode {
    return new EmojiNode(node.__emojiId, node.__key);
  }
  override isInline(): boolean {
    return true;
  }
  canInsertTextBefore(): boolean {
    return true;
  }
  canInsertTextAfter(): boolean {
    return true;
  }
  override createDOM(_config: EditorConfig): HTMLElement {
    const span = document.createElement("span");
    return span;
  }
  override updateDOM(_prevNode: EmojiNode, _dom: HTMLElement, _config: EditorConfig): boolean {
    return false;
  }
  override decorate(_editor: LexicalEditor, _config: EditorConfig): JSX.Element {
    return createElement(EmojiComponent, {
      emojiId: this.__emojiId
    });
  }
  static override importJSON(serializedNode: SerializedEmojiNode): EmojiNode {
    return new EmojiNode(serializedNode.emojiId);
  }
  override exportJSON(): SerializedEmojiNode {
    return {
      type: "emoji",
      version: 1,
      emojiId: this.__emojiId
    };
  }
}
const EmojiComponent = t0 => {
  const $ = _c(13);
  const {
    emojiId
  } = t0;
  const {
    findCustomEmoji,
    findNativeEmoji
  } = useEmoji();
  let t1;
  if ($[0] !== emojiId || $[1] !== findCustomEmoji) {
    t1 = findCustomEmoji(emojiId);
    $[0] = emojiId;
    $[1] = findCustomEmoji;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const emoji = t1;
  if (!emoji) {
    let t2;
    if ($[3] !== emojiId || $[4] !== findNativeEmoji) {
      t2 = findNativeEmoji(emojiId);
      $[3] = emojiId;
      $[4] = findNativeEmoji;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const nativeEmoji = t2;
    if (nativeEmoji) {
      const t3 = nativeEmoji.skins[0]?.native;
      let t4;
      if ($[6] !== t3) {
        t4 = <span>{t3}</span>;
        $[6] = t3;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      return t4;
    }
    const t3 = `:${emojiId}:`;
    let t4;
    if ($[8] !== t3) {
      t4 = <span>{t3}</span>;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  const t2 = emoji.skins[0]?.src;
  let t3;
  if ($[10] !== emojiId || $[11] !== t2) {
    t3 = <img src={t2} alt={emojiId} className="emoji-node" />;
    $[10] = emojiId;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};